import React, { ChangeEvent, useEffect, useState } from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import { SELECT_AN_OPTION } from 'components/Dialogs/common/constants';
import { Question } from 'dashboard409a/pages/Information/types';
import theme from 'theme';
import { ProcessManagementQuestionsFormDropdownInputProps } from './types';
import ProcessManagementQuestionsFormTextInput from '../ProcessManagementQuestionsFormTextInput/ProcessManagementQuestionsFormTextInput';

const ProcessManagementQuestionsFormDropdownInput = ({
  answerToDisplay,
  handleAnswerQuestion,
  options,
  childrenQuestions,
  setChildrenAnswer,
  getQuestionStatus,
}: ProcessManagementQuestionsFormDropdownInputProps) => {
  const [answer, setAnswer] = useState<number>(answerToDisplay ?? 0);
  const [{ user }] = useStore() as unknown as UseStoreValues;

  const handleChange = (event: ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as number;
    setAnswer(value);
    handleAnswerQuestion(value);
  };

  useEffect(() => {
    setAnswer(answerToDisplay ?? 0);
  }, [answerToDisplay]);

  return (
    <FormControl variant="outlined">
      <Select
        labelId="question-input-select-label"
        id="question-input-select"
        value={answer || ''}
        onChange={handleChange}
        displayEmpty
        style={{
          borderRadius: '8px',
          border: `1px solid ${theme.palette.primary[700]}`,
          marginBottom: '1rem',
          color: theme.palette.primary[700],
        }}>
        <MenuItem value="" disabled>
          {SELECT_AN_OPTION}
        </MenuItem>
        {options.map(option => (
          <MenuItem key={option.id} value={option.id} style={{ color: theme.palette.primary[700] }}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
      {childrenQuestions?.map((questionParam: Question) => (
        <ProcessManagementQuestionsFormTextInput
          key={questionParam.id}
          answerToDisplay={user ? questionParam?.answers?.[0]?.text_answer ?? '' : ''}
          handleAnswerQuestion={setChildrenAnswer}
          placeholder={questionParam.name}
          isAnswered={getQuestionStatus(questionParam)}
        />
      ))}
    </FormControl>
  );
};

export default ProcessManagementQuestionsFormDropdownInput;
